import { createSlice } from "@reduxjs/toolkit";
import CryptoJS from "crypto-js";
import letter3Dictionary from "../database/Letter3Dictionary";

const secretKey = "my little secret";

export const decryptData = (encryptedData) => {
  const decryptedData = CryptoJS.AES.decrypt(encryptedData, secretKey).toString(
    CryptoJS.enc.Utf8
  );
  return JSON.parse(decryptedData);
};

function compareWords(word1, word2) {
  const result = [];

  for (let i = 0; i < 3; i++) {
    for (let j = 0; j < 3; j++) {
      if (word1[i] === word2[j]) {
        result.push({ index: i, word: word1[i] });
      }
    }
  }

  const uniqueArray = [];
  const uniqueWords = {};

  result.forEach(({ index, word }) => {
    if (!uniqueWords[word]) {
      uniqueWords[word] = true;
      uniqueArray.push({ index, word });
    }
  });

  return uniqueArray;
}

const initialState = localStorage.getItem("word3Result")
  ? JSON.parse(localStorage.getItem("word3Result"))
  : {
      enteredWord1EnterPressed: false,
      enteredWord2EnterPressed: false,
      enteredWord3EnterPressed: false,
      enteredWord4EnterPressed: false,
      enteredWord5EnterPressed: false,
      word1Check: null,
      word1CheckDictionary: null,
      word2Check: null,
      word2CheckDictionary: null,
      word3Check: null,
      word3CheckDictionary: null,
      word4Check: null,
      word4CheckDictionary: null,
      word5Check: null,
      word5CheckDictionary: null,
    };

const word3ResultSlice = createSlice({
  name: "word3ResultSlice",
  initialState,
  reducers: {
    word1CheckHandler: (state, action) => {
      const { targetedWord, word } = action.payload;
      const targetWord = decryptData(targetedWord);
      console.log(targetWord, "t");
      console.log(word, "w");
      if (!letter3Dictionary?.includes(word.toLowerCase())) {
        state.word1CheckDictionary = false;
        state.enteredWord1EnterPressed = true;
      } else if (word.toUpperCase() == targetWord.toUpperCase()) {
        state.word1CheckDictionary = true;
        state.enteredWord1EnterPressed = true;
        state.word1Check = true;
      } else {
        state.word1CheckDictionary = true;
        state.enteredWord1EnterPressed = true;
        const result = compareWords(
          word.toUpperCase(),
          targetWord.toUpperCase()
        );
        state.word1Check = result;
      }

      localStorage.setItem("word3Result", JSON.stringify(state));
      return state;
    },
    word2CheckHandler: (state, action) => {
      const { targetedWord, word } = action.payload;
      const targetWord = decryptData(targetedWord);
      if (!letter3Dictionary?.includes(word.toLowerCase())) {
        state.enteredWord2EnterPressed = true;
        state.word2CheckDictionary = false;
      } else if (word.toUpperCase() == targetWord.toUpperCase()) {
        state.word2CheckDictionary = true;
        state.enteredWord2EnterPressed = true;
        state.word2Check = true;
      } else {
        state.word2CheckDictionary = true;
        state.enteredWord2EnterPressed = true;
        const result = compareWords(
          word.toUpperCase(),
          targetWord.toUpperCase()
        );
        state.word2Check = result;
      }
      localStorage.setItem("word3Result", JSON.stringify(state));
      return state;
    },
    word3CheckHandler: (state, action) => {
      const { targetedWord, word } = action.payload;
      const targetWord = decryptData(targetedWord);
      if (!letter3Dictionary?.includes(word.toLowerCase())) {
        state.enteredWord3EnterPressed = true;
        state.word3CheckDictionary = false;
      } else if (word.toUpperCase() == targetWord.toUpperCase()) {
        state.word3CheckDictionary = true;
        state.enteredWord3EnterPressed = true;
        state.word3Check = true;
      } else {
        state.enteredWord3EnterPressed = true;
        state.word3CheckDictionary = true;
        const result = compareWords(
          word.toUpperCase(),
          targetWord.toUpperCase()
        );
        state.word3Check = result;
      }
      localStorage.setItem("word3Result", JSON.stringify(state));
      return state;
    },
    word4CheckHandler: (state, action) => {
      const { targetedWord, word } = action.payload;
      const targetWord = decryptData(targetedWord);
      if (!letter3Dictionary?.includes(word.toLowerCase())) {
        state.enteredWord4EnterPressed = true;
        state.word4CheckDictionary = false;
      } else if (word.toUpperCase() == targetWord.toUpperCase()) {
        state.word4CheckDictionary = true;
        state.enteredWord4EnterPressed = true;
        state.word4Check = true;
      } else {
        state.word4CheckDictionary = true;
        state.enteredWord4EnterPressed = true;
        const result = compareWords(
          word.toUpperCase(),
          targetWord.toUpperCase()
        );
        state.word4Check = result;
      }
      localStorage.setItem("word3Result", JSON.stringify(state));
      return state;
    },
    word5CheckHandler: (state, action) => {
      const { targetedWord, word } = action.payload;
      const targetWord = decryptData(targetedWord);
      console.log(word, "word");
      if (!letter3Dictionary?.includes(word.toLowerCase())) {
        state.enteredWord5EnterPressed = true;
        state.word5CheckDictionary = false;
      } else if (word.toUpperCase() == targetWord.toUpperCase()) {
        state.word5CheckDictionary = true;
        state.enteredWord5EnterPressed = true;
        state.word5Check = true;
      } else {
        state.enteredWord5EnterPressed = true;
        state.word5CheckDictionary = true;
        const result = compareWords(
          word.toUpperCase(),
          targetWord.toUpperCase()
        );
        state.word5Check = result;
      }
      localStorage.setItem("word3Result", JSON.stringify(state));
      return state;
    },
    resetEnteredWord1: (state, action) => {
      state.word1CheckDictionary = null;
      state.enteredWord1EnterPressed = false;
      localStorage.setItem("word3Result", JSON.stringify(state));
      return state;
    },
    resetEnteredWord2: (state, action) => {
      state.word2CheckDictionary = null;
      state.enteredWord2EnterPressed = false;
      localStorage.setItem("word3Result", JSON.stringify(state));
      return state;
    },
    resetEnteredWord3: (state, action) => {
      state.word3CheckDictionary = null;
      state.enteredWord3EnterPressed = false;
      localStorage.setItem("word3Result", JSON.stringify(state));
      return state;
    },
    resetEnteredWord4: (state, action) => {
      state.word4CheckDictionary = null;
      state.enteredWord4EnterPressed = false;
      localStorage.setItem("word3Result", JSON.stringify(state));
      return state;
    },
    resetEnteredWord5: (state, action) => {
      state.word5CheckDictionary = null;
      state.enteredWord5EnterPressed = false;
      localStorage.setItem("word3Result", JSON.stringify(state));
      return state;
    },
    resetWord3Result: (state, action) => {
      state.enteredWord1EnterPressed = false;
      state.enteredWord2EnterPressed = false;
      state.enteredWord3EnterPressed = false;
      state.enteredWord4EnterPressed = false;
      state.enteredWord5EnterPressed = false;
      state.word1Check = null;
      state.word1CheckDictionary = null;
      state.word2Check = null;
      state.word2CheckDictionary = null;
      state.word3Check = null;
      state.word3CheckDictionary = null;
      state.word4Check = null;
      state.word4CheckDictionary = null;
      state.word5Check = null;
      state.word5CheckDictionary = null;
      localStorage.removeItem("word3Result", JSON.stringify(state));
      return state;
    },
  },
});
export const {
  word1CheckHandler,
  word2CheckHandler,
  word3CheckHandler,
  word4CheckHandler,
  word5CheckHandler,
  resetEnteredWord1,
  resetEnteredWord2,
  resetEnteredWord3,
  resetEnteredWord4,
  resetEnteredWord5,
  resetWord3Result,
} = word3ResultSlice.actions;
export default word3ResultSlice;
